import { translation } from "../../../helper/translation"

export const ContentHomePageCategories = () => {

    const categories = [
        ["experience", "experience-content", "fa-user-tie"],
        ["projects", "projects-content", "fa-tasks"],
        ["lines-of-code","lines-of-code-content", "fa-code"],
        ["client-revenue", "client-revenue-content", "fa-chart-line"]
    ]
    return(
        <div className="top-categories">
            <div className="container">
            <div className="row">
                {
                    categories.map((el, index) => {
                        return(
                            <div key={index} className="col-lg col-sm-5">
                                <div className="item">
                                    <div className="icon">
                                        {/* <span className={el[3]} /> */}
                                        <i className={`fa ${el[2]} f-size-25`}></i>
                                    </div>
                                    <h4>{translation(el[0])}</h4>
                                    <span>{translation(el[1])}</span>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    </div>
    )
}